/**
 * Run a registry action (`lib/actions.ts`) from anywhere in the app.
 *
 * `App` owns the `ActionContext` — the workspace, the dispatch, the catalog —
 * and publishes a runner here; a component mounted far from it (the data panel,
 * which may even be in a detached window) calls `runAction` instead of being
 * handed a dispatch it would have to thread through every host. Module scope,
 * `bar-intel-store.ts`' shape.
 *
 * Before `App` has published, a call is refused with a reason, never dropped.
 */

import type { ActionOutcome } from "./actions";

type Runner = (id: string, args: Record<string, unknown>) => ActionOutcome;

let runner: Runner | undefined;

/** `App` publishes its runner; `undefined` withdraws it on unmount. */
export function setActionRunner(next: Runner | undefined): void {
  runner = next;
}

export function runAction(id: string, args: Record<string, unknown> = {}): ActionOutcome {
  return runner ? runner(id, args) : { ok: false, reason: "the app is still starting — try again in a moment" };
}
